import api from '../../../api';

export function getCustomerData(key) {
	return api.post(`/search-orders`, { key });
}

export function getCrmCategories() {
	return api.get('/get-crm-category');
};

export function getAllCrmCategories() {
  return api.get('/get-all-crm-category');
}

export function getHelpAndSupportCategories() {
  return api.get('/get-help-and-support-category-subcat');
}

export function postTicket(payload) {
	return api.post('/v2/create-ticket', payload);
};

export const getTicketConfig = caseId => {
	return api.get(`/get-ticket-config/${caseId}`);
};

export const getTicketConfigByOrderId = (orderId, categoryKey) => {
	if (!orderId) return;
	const encodedOrderId = encodeURIComponent(orderId);
	return api.get(`/get-ticket-config-by-order-id/${encodedOrderId}`, {
		params: { categoryKey },
	});
};



export const getTicketSlot = (subcategory = 'customer_complaints', language) => {
	return api.get(`/get-ticket-slots/${subcategory}`, {
		params: language ? { language } : {}
	});
};

export const getCxComplaintTicket = (startDate, endDate, PageNumber, query) => {
    return api.get(`/get-cx-complaints-ticket/${startDate}/${endDate}?pageNumber=${PageNumber}${query && query.length ? `&${query}` : ``}`);
};

export const updateTicketsCaseIds = (ticketIds) => {
    return api.post('/update-tickets-case-ids', { ticketIds });
};

export const getOngoingEngagement = (caseId) => {
    return api.get(`/v2/ongoing-engagement/${caseId}`);
};
